import { setCookie } from '../../utils';

export const logout = () => {
  let init = { method: 'DELETE', credentials: 'include' };
  return fetch('/ai-web/boxuser/logout', init)
    .then(res => res.json(), err => console.error(err))
    .then(result => {
      setCookie('userToken', '', -1);
      return result;
    });
};

export const logout4CT = () => {
  let init = { method: 'DELETE', credentials: 'include' };
  return fetch('/ai-web-ct/boxuser/logout', init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const login = post => {
  const init = {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(post),
  };
  return fetch(`/ai-web/boxuser/login`, init)
    .then(res => res.json(), err => console.error(err))
    .then(result => {
      setCookie('userToken', result.data, 30);
      return result;
    });
};

// 不带验证码的登录
export const loginWithOutVCode = post => {
  const init = {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(post),
  };
  return fetch(`/ai-web/boxuser/loginWithOutVCode`, init)
    .then(res => res.json(), err => console.error(err))
    .then(result => {
      setCookie('userToken', result.data, 30);
      return result;
    });
};

export const register = post => {
  const init = {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(post),
  };
  return fetch('/ai-web/user/register', init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const verify = post => {
  const init = {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(post),
  };
  return fetch('/ai-web/user/active', init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const dicomCount = () => {
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
  };
  return fetch('/ai-web/fromDr/dicomCount', init).then(
    res => res.json(),
    error => console.error(error)
  );
};

export const userCount = () => {
  const init = {
    method: 'GET',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
  };
  return fetch('/ai-web/boxuser/userCount', init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//向邮箱发送验证码
export const sendVCodeToEmail = email => {
  const init = {
    method: 'GET',
  };
  return fetch(`/ai-web/boxuser/sendVCodeToEmail?email=${email}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//邮箱登录
export const loginFromEmail = data => {
  const init = {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  };

  return fetch(`/ai-web/boxuser/loginFromEmail`, init)
    .then(res => res.json(), err => console.error(err))
    .then(result => {
      setCookie('userToken', result.data, 30);
      return result;
    });
};

//获取应用图片格式
export const dcm4cheeType = () => {
  return fetch(`/dcm4cheeType`).then(
    res => res.json(),
    err => console.error(err)
  );
};

//获取地址
export const dcm4cheepath = () => {
  return fetch(`/dcm4cheepath`).then(
    res => res.json(),
    err => console.error(err)
  );
};

//获取地址
export const ctDcm4cheepath = () => {
  return fetch(`/dcm4cheepath-ct`).then(
    res => res.json(),
    err => console.error(err)
  );
};

//修改密码
export const modifyPWD = data => {
  const init = {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  };
  return fetch('/ai-web/boxuser/modifyPWD', init).then(
    res => res.json(),
    err => console.error(err)
  );
};

export const getCityjson = () => {
  return fetch(`https://api.db-ip.com/v2/free/self`).then(
    res => res.json(),
    err => console.error(err)
  );
};

//获取系统提示
export const noticeList = () => {
  const data = { type: 1 };
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/system/noticeList`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//登录CT系统
export const login4CT = token => {
  const init = {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: token,
  };
  return fetch(`/ai-web-ct/boxuser/login4Third`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//账号密码的登录发送验证码
export const sendVCodeToEmailUseAcc = data => {
  const init = {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web/boxuser/sendVCodeToEmailUseAcc`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
